import {
  DELETE_ASSIGNMENT_EXTENSIONS_FAILURE,
  DELETE_ASSIGNMENT_EXTENSIONS_REQUEST,
  DELETE_ASSIGNMENT_EXTENSIONS_SUCCESS,
  DELETE_ASSIGNMENT_TRIPS_FAILURE,
  DELETE_ASSIGNMENT_TRIPS_REQUEST,
  DELETE_ASSIGNMENT_TRIPS_SUCCESS,
  DELETE_AUTHORIZATIONS_FAILURE,
  DELETE_AUTHORIZATIONS_REQUEST,
  DELETE_AUTHORIZATIONS_SUCCESS,
  DELETE_AUTH_HOUSE_HUNTING_LIST_FAILURE,
  DELETE_AUTH_HOUSE_HUNTING_LIST_REQUEST,
  DELETE_AUTH_HOUSE_HUNTING_LIST_SUCCESS,
  DELETE_AUTH_LIST_CLIENT_POLICIES_FAILURE,
  DELETE_AUTH_LIST_CLIENT_POLICIES_REQUEST,
  DELETE_AUTH_LIST_CLIENT_POLICIES_SUCCESS,
  DELETE_AUTH_OFFER_HISTORY_LIST_FAILURE,
  DELETE_AUTH_OFFER_HISTORY_LIST_REQUEST,
  DELETE_AUTH_OFFER_HISTORY_LIST_SUCCESS,
  DELETE_AUTH_SERVICES_FAILURE,
  DELETE_AUTH_SERVICES_REQUEST,
  DELETE_AUTH_SERVICES_SUCCESS,
  DELETE_BROKER_AGENTS_FAILURE,
  DELETE_BROKER_AGENTS_REQUEST,
  DELETE_BROKER_AGENTS_SUCCESS,
  DELETE_CANDIDATE_TRIP_FAILURE,
  DELETE_CANDIDATE_TRIP_REQUEST,
  DELETE_CANDIDATE_TRIP_SUCCESS,
  DELETE_CREDIT_FAILURE,
  DELETE_CREDIT_REQUEST,
  DELETE_CREDIT_SUCCESS,
  DELETE_EQUITY_FAILURE,
  DELETE_EQUITY_REQUEST,
  DELETE_EQUITY_SUCCESS,
  DELETE_EXPENSE_CODES_FAILURE,
  DELETE_EXPENSE_CODES_REQUEST,
  DELETE_EXPENSE_CODES_SUCCESS,
  DELETE_FAMILY_FAILURE,
  DELETE_FAMILY_PET_FAILURE,
  DELETE_FAMILY_PET_REQUEST,
  DELETE_FAMILY_PET_SUCCESS,
  DELETE_FAMILY_REQUEST,
  DELETE_FAMILY_SUCCESS,
  DELETE_GLOBAL_DESTINATION_SERVICES_FAILURE,
  DELETE_GLOBAL_DESTINATION_SERVICES_REQUEST,
  DELETE_GLOBAL_DESTINATION_SERVICES_SUCCESS,
  DELETE_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE,
  DELETE_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST,
  DELETE_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS,
  DELETE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_FAILURE,
  DELETE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_REQUEST,
  DELETE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_SUCCESS,
  DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE,
  DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST,
  DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
  DELETE_GLOBAL_LANGUAGE_TRAINING_FAILURE,
  DELETE_GLOBAL_LANGUAGE_TRAINING_REQUEST,
  DELETE_GLOBAL_LANGUAGE_TRAINING_SUCCESS,
  DELETE_HHG_ITEMS_FAILURE,
  DELETE_HHG_ITEMS_REQUEST,
  DELETE_HHG_ITEMS_SUCCESS,
  DELETE_HHG_MOVING_DATE_FAILURE,
  DELETE_HHG_MOVING_DATE_REQUEST,
  DELETE_HHG_MOVING_DATE_SUCCESS,
  DELETE_HOMESALE_RESALE_OFFER_FAILURE,
  DELETE_HOMESALE_RESALE_OFFER_REQUEST,
  DELETE_HOMESALE_RESALE_OFFER_SUCCESS,
  DELETE_INSPECTIONS_FAILURE,
  DELETE_INSPECTIONS_REQUEST,
  DELETE_INSPECTORS_FAILURE,
  DELETE_INSPECTORS_REQUEST,
  DELETE_INSPECTORS_SUCCESS,
  DELETE_TAX_FAILURE,
  DELETE_TAX_POLICY_FAILURE,
  DELETE_TAX_POLICY_REQUEST,
  DELETE_TAX_POLICY_SUCCESS,
  DELETE_TAX_REQUEST,
  DELETE_TAX_SUCCESS,
  DELETE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE,
  DELETE_TEMPORARY_LIVING_ASSIGNMENT_REQUEST,
  DELETE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
  DELETE_TITLE_REP_FAILURE,
  DELETE_TITLE_REP_REQUEST,
  DELETE_TITLE_REP_SUCCESS,
  DELETE_VENDORS_FAILURE,
  DELETE_VENDORS_REQUEST,
  DELETE_VENDORS_SUCCESS,
  DELETE_VENDOR_CONTACT_FAILURE,
  DELETE_VENDOR_CONTACT_REQUEST,
  DELETE_VENDOR_CONTACT_SUCCESS,
  GET_ACTIVITY_LOG_FAILURE,
  GET_ACTIVITY_LOG_REQUEST,
  GET_ACTIVITY_LOG_SUCCESS,
  GET_ALL_AUTH_SERVICES_FAILURE,
  GET_ALL_AUTH_SERVICES_REQUEST,
  GET_ALL_AUTH_SERVICES_SUCCESS,
  GET_ALL_BROKER_AGENTS_FAILURE,
  GET_ALL_BROKER_AGENTS_REQUEST,
  GET_ALL_BROKER_AGENTS_SUCCESS,
  GET_ALL_CANDIDATE_TRIPS_FAILURE,
  GET_ALL_CANDIDATE_TRIPS_REQUEST,
  GET_ALL_CANDIDATE_TRIPS_SUCCESS,
  GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE,
  GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST,
  GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS,
  GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_TENANTS_FAILURE,
  GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_TENANTS_REQUEST,
  GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_TENANTS_SUCCESS,
  GET_ALL_HOMESALE_RESALE_OFFER_FAILURE,
  GET_ALL_HOMESALE_RESALE_OFFER_REQUEST,
  GET_ALL_HOMESALE_RESALE_OFFER_SUCCESS,
  GET_APPRAISALS_FAILURE,
  GET_APPRAISALS_REQUEST,
  GET_APPRAISALS_SUCCESS,
  GET_ASSIGNMENT_EXTENSIONS_FAILURE,
  GET_ASSIGNMENT_EXTENSIONS_REQUEST,
  GET_ASSIGNMENT_EXTENSIONS_SUCCESS,
  GET_ASSIGNMENT_TRIPS_FAILURE,
  GET_ASSIGNMENT_TRIPS_REQUEST,
  GET_ASSIGNMENT_TRIPS_SUCCESS,
  GET_AUTHORIZATIONS_FAILURE,
  GET_AUTHORIZATIONS_REQUEST,
  GET_AUTHORIZATIONS_SUCCESS,
  GET_AUTH_CLIENT_POLICIES_FAILURE,
  GET_AUTH_CLIENT_POLICIES_REQUEST,
  GET_AUTH_CLIENT_POLICIES_SUCCESS,
  GET_AUTH_DATE_SUMMARY_FAILURE,
  GET_AUTH_DATE_SUMMARY_REQUEST,
  GET_AUTH_DATE_SUMMARY_SUCCESS,
  GET_AUTH_DESTINATION_SERVICES_FAILURE,
  GET_AUTH_DESTINATION_SERVICES_REQUEST,
  GET_AUTH_DESTINATION_SERVICES_SUCCESS,
  GET_AUTH_HOUSE_HUNTING_LIST_FAILURE,
  GET_AUTH_HOUSE_HUNTING_LIST_REQUEST,
  GET_AUTH_HOUSE_HUNTING_LIST_SUCCESS,
  GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_FAILURE,
  GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_REQUEST,
  GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_SUCCESS,
  GET_AUTH_LIST_CLIENT_POLICIES_FAILURE,
  GET_AUTH_LIST_CLIENT_POLICIES_REQUEST,
  GET_AUTH_LIST_CLIENT_POLICIES_SUCCESS,
  GET_AUTH_OFFER_HISTORY_LIST_FAILURE,
  GET_AUTH_OFFER_HISTORY_LIST_REQUEST,
  GET_AUTH_OFFER_HISTORY_LIST_SUCCESS,
  GET_AUTH_PETS_FAILURE,
  GET_AUTH_PETS_REQUEST,
  GET_AUTH_PETS_SUCCESS,
  GET_AUTH_SERVICES_FAILURE,
  GET_AUTH_SERVICES_REQUEST,
  GET_AUTH_SERVICES_SUCCESS,
  GET_AUTH_SUMMARY_FAILURE,
  GET_AUTH_SUMMARY_REQUEST,
  GET_AUTH_SUMMARY_SUCCESS,
  GET_AUTH_TAX_ASSISTANCE_FAILURE,
  GET_AUTH_TAX_ASSISTANCE_REQUEST,
  GET_AUTH_TAX_ASSISTANCE_SUCCESS,
  GET_AUTH_TEAM_FAILURE,
  GET_AUTH_TEAM_REQUEST,
  GET_AUTH_TEAM_SUCCESS,
  GET_BROKER_AGENTS_BY_ID_FAILURE,
  GET_BROKER_AGENTS_BY_ID_REQUEST,
  GET_BROKER_AGENTS_BY_ID_SUCCESS,
  GET_CANDIDATE_SERVICES_FAILURE,
  GET_CANDIDATE_SERVICES_REQUEST,
  GET_CANDIDATE_SERVICES_SUCCESS,
  GET_CANDIDATE_TRIP_FAILURE,
  GET_CANDIDATE_TRIP_REQUEST,
  GET_CANDIDATE_TRIP_SUCCESS,
  GET_COMMUNICATION_INFO_FAILURE,
  GET_COMMUNICATION_INFO_REQUEST,
  GET_COMMUNICATION_INFO_SUCCESS,
  GET_COST_ESTIMATES_FAILURE,
  GET_COST_ESTIMATES_REQUEST,
  GET_COST_ESTIMATES_SUCCESS,
  GET_CREDIT_FAILURE,
  GET_CREDIT_REQUEST,
  GET_CREDIT_SUCCESS,
  GET_DEPARTURE_ADDRESS_FAILURE,
  GET_DEPARTURE_ADDRESS_REQUEST,
  GET_DEPARTURE_ADDRESS_SUCCESS,
  GET_DESTINATION_ADDRESS_FAILURE,
  GET_DESTINATION_ADDRESS_REQUEST,
  GET_DESTINATION_ADDRESS_SUCCESS,
  GET_EMPLOYEE_INFO_FAILURE,
  GET_EMPLOYEE_INFO_REQUEST,
  GET_EMPLOYEE_INFO_SUCCESS,
  GET_EQUITY_FAILURE,
  GET_EQUITY_REQUEST,
  GET_EQUITY_SUCCESS,
  GET_EXPENSE_CODES_FAILURE,
  GET_EXPENSE_CODES_REQUEST,
  GET_EXPENSE_CODES_SUCCESS,
  GET_FAMILY_FAILURE,
  GET_FAMILY_PET_FAILURE,
  GET_FAMILY_PET_REQUEST,
  GET_FAMILY_PET_SUCCESS,
  GET_FAMILY_REQUEST,
  GET_FAMILY_SUCCESS,
  GET_GLOBAL_DESTINATION_SERVICES_FAILURE,
  GET_GLOBAL_DESTINATION_SERVICES_REQUEST,
  GET_GLOBAL_DESTINATION_SERVICES_SUCCESS,
  GET_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE,
  GET_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST,
  GET_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS,
  GET_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_FAILURE,
  GET_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_REQUEST,
  GET_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_SUCCESS,
  GET_GLOBAL_INFO_FAILURE,
  GET_GLOBAL_INFO_REQUEST,
  GET_GLOBAL_INFO_SUCCESS,
  GET_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE,
  GET_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST,
  GET_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
  GET_GLOBAL_LANGUAGE_TRAINING_FAILURE,
  GET_GLOBAL_LANGUAGE_TRAINING_REQUEST,
  GET_GLOBAL_LANGUAGE_TRAINING_SUCCESS,
  GET_HHG_ESTIMATES_FAILURE,
  GET_HHG_ESTIMATES_REQUEST,
  GET_HHG_ESTIMATES_SUCCESS,
  GET_HHG_ITEMS_FAILURE,
  GET_HHG_ITEMS_REQUEST,
  GET_HHG_ITEMS_SUCCESS,
  GET_HHG_MOVING_DATE_FAILURE,
  GET_HHG_MOVING_DATE_REQUEST,
  GET_HHG_MOVING_DATE_SUCCESS,
  GET_HHG_SEGMENTS_FAILURE,
  GET_HHG_SEGMENTS_REQUEST,
  GET_HHG_SEGMENTS_SUCCESS,
  GET_HOMESALE_INFO_FAILURE,
  GET_HOMESALE_INFO_REQUEST,
  GET_HOMESALE_INFO_SUCCESS,
  GET_HOMESALE_RESALE_OFFER_FAILURE,
  GET_HOMESALE_RESALE_OFFER_REQUEST,
  GET_HOMESALE_RESALE_OFFER_SUCCESS,
  GET_INSPECTIONS_FAILURE,
  GET_INSPECTIONS_REQUEST,
  GET_INSPECTIONS_SUCCESS,
  GET_INSPECTORS_FAILURE,
  GET_INSPECTORS_REQUEST,
  GET_INSPECTORS_SUCCESS,
  GET_INTERN_SERVICES_FAILURE,
  GET_INTERN_SERVICES_REQUEST,
  GET_INTERN_SERVICES_SUCCESS,
  GET_LISTINGS_FAILURE,
  GET_LISTINGS_REQUEST,
  GET_LISTINGS_SUCCESS,
  GET_SO_INFO_FAILURE,
  GET_SO_INFO_REQUEST,
  GET_SO_INFO_SUCCESS,
  GET_TAX_FAILURE,
  GET_TAX_POLICIES_BY_CLIENT_FAILURE,
  GET_TAX_POLICIES_BY_CLIENT_REQUEST,
  GET_TAX_POLICIES_BY_CLIENT_SUCCESS,
  GET_TAX_POLICIES_FAILURE,
  GET_TAX_POLICIES_REQUEST,
  GET_TAX_POLICIES_SUCCESS,
  GET_TAX_REQUEST,
  GET_TAX_SUCCESS,
  GET_TEMPORARY_LIVING_ASSIGNMENT_FAILURE,
  GET_TEMPORARY_LIVING_ASSIGNMENT_REQUEST,
  GET_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
  GET_TITLE_REP_FAILURE,
  GET_TITLE_REP_REQUEST,
  GET_TITLE_REP_SUCCESS,
  GET_USER_SETTINGS_FAILURE,
  GET_USER_SETTINGS_REQUEST,
  GET_USER_SETTINGS_SUCCESS,
  GET_VENDORS_FAILURE,
  GET_VENDORS_REQUEST,
  GET_VENDORS_SUCCESS,
  GET_VENDOR_CONTACT_FAILURE,
  GET_VENDOR_CONTACT_REQUEST,
  GET_VENDOR_CONTACT_SUCCESS,
  POST_APPRAISALS_FAILURE,
  POST_APPRAISALS_REQUEST,
  POST_APPRAISALS_SUCCESS,
  POST_ASSIGNMENT_EXTENSIONS_FAILURE,
  POST_ASSIGNMENT_EXTENSIONS_REQUEST,
  POST_ASSIGNMENT_EXTENSIONS_SUCCESS,
  POST_AUTHORIZATIONS_FAILURE,
  POST_AUTHORIZATIONS_REQUEST,
  POST_AUTHORIZATIONS_SUCCESS,
  POST_AUTH_CLIENT_POLICIES_FAILURE,
  POST_AUTH_CLIENT_POLICIES_REQUEST,
  POST_AUTH_CLIENT_POLICIES_SUCCESS,
  POST_AUTH_DATE_SUMMARY_FAILURE,
  POST_AUTH_DATE_SUMMARY_REQUEST,
  POST_AUTH_DATE_SUMMARY_SUCCESS,
  POST_AUTH_DESTINATION_SERVICES_REQUEST,
  POST_AUTH_DESTINATION_SERVICES_SUCCESS,
  POST_AUTH_HOUSE_HUNTING_LIST_FAILURE,
  POST_AUTH_HOUSE_HUNTING_LIST_REQUEST,
  POST_AUTH_HOUSE_HUNTING_LIST_SUCCESS,
  POST_AUTH_LIST_CLIENT_POLICIES_FAILURE,
  POST_AUTH_LIST_CLIENT_POLICIES_REQUEST,
  POST_AUTH_LIST_CLIENT_POLICIES_SUCCESS,
  POST_AUTH_OFFER_HISTORY_LIST_FAILURE,
  POST_AUTH_OFFER_HISTORY_LIST_REQUEST,
  POST_AUTH_OFFER_HISTORY_LIST_SUCCESS,
  POST_AUTH_PETS_FAILURE,
  POST_AUTH_PETS_REQUEST,
  POST_AUTH_PETS_SUCCESS,
  POST_AUTH_SERVICES_FAILURE,
  POST_AUTH_SERVICES_REQUEST,
  POST_AUTH_SERVICES_SUCCESS,
  POST_AUTH_TAX_ASSISTANCE_FAILURE,
  POST_AUTH_TAX_ASSISTANCE_REQUEST,
  POST_AUTH_TAX_ASSISTANCE_SUCCESS,
  POST_AUTH_TEAM_FAILURE,
  POST_AUTH_TEAM_REQUEST,
  POST_AUTH_TEAM_SUCCESS,
  POST_BROKER_AGENTS_FAILURE,
  POST_BROKER_AGENTS_REQUEST,
  POST_BROKER_AGENTS_SUCCESS,
  POST_CANDIDATE_SERVICES_FAILURE,
  POST_CANDIDATE_SERVICES_REQUEST,
  POST_CANDIDATE_SERVICES_SUCCESS,
  POST_COMMUNICATION_INFO_FAILURE,
  POST_COMMUNICATION_INFO_REQUEST,
  POST_COMMUNICATION_INFO_SUCCESS,
  POST_COST_ESTIMATES_FAILURE,
  POST_COST_ESTIMATES_REQUEST,
  POST_COST_ESTIMATES_SUCCESS,
  POST_CREDIT_FAILURE,
  POST_CREDIT_REQUEST,
  POST_CREDIT_SUCCESS,
  POST_DEPARTURE_ADDRESS_FAILURE,
  POST_DEPARTURE_ADDRESS_REQUEST,
  POST_DEPARTURE_ADDRESS_SUCCESS,
  POST_DESTINATION_ADDRESS_FAILURE,
  POST_DESTINATION_ADDRESS_REQUEST,
  POST_DESTINATION_ADDRESS_SUCCESS,
  POST_EMPLOYEE_INFO_FAILURE,
  POST_EMPLOYEE_INFO_REQUEST,
  POST_EMPLOYEE_INFO_SUCCESS,
  POST_EQUITY_FAILURE,
  POST_EQUITY_REQUEST,
  POST_EQUITY_SUCCESS,
  POST_EXPENSE_CODES_FAILURE,
  POST_EXPENSE_CODES_REQUEST,
  POST_EXPENSE_CODES_SUCCESS,
  POST_FAMILY_FAILURE,
  POST_FAMILY_PET_FAILURE,
  POST_FAMILY_PET_REQUEST,
  POST_FAMILY_PET_SUCCESS,
  POST_FAMILY_REQUEST,
  POST_FAMILY_SUCCESS,
  POST_GLOBAL_DESTINATION_SERVICES_FAILURE,
  POST_GLOBAL_DESTINATION_SERVICES_REQUEST,
  POST_GLOBAL_DESTINATION_SERVICES_SUCCESS,
  POST_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE,
  POST_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST,
  POST_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS,
  POST_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_FAILURE,
  POST_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_REQUEST,
  POST_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_SUCCESS,
  POST_GLOBAL_INFO_FAILURE,
  POST_GLOBAL_INFO_REQUEST,
  POST_GLOBAL_INFO_SUCCESS,
  POST_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE,
  POST_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST,
  POST_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
  POST_GLOBAL_LANGUAGE_TRAINING_FAILURE,
  POST_GLOBAL_LANGUAGE_TRAINING_REQUEST,
  POST_GLOBAL_LANGUAGE_TRAINING_SUCCESS,
  POST_HHG_ESTIMATE_FAILURE,
  POST_HHG_ESTIMATE_REQUEST,
  POST_HHG_ESTIMATE_SUCCESS,
  POST_HHG_ITEMS_FAILURE,
  POST_HHG_ITEMS_REQUEST,
  POST_HHG_ITEMS_SUCCESS,
  POST_HHG_MOVING_DATE_FAILURE,
  POST_HHG_MOVING_DATE_REQUEST,
  POST_HHG_MOVING_DATE_SUCCESS,
  POST_HHG_SEGMENT_FAILURE,
  POST_HHG_SEGMENT_REQUEST,
  POST_HHG_SEGMENT_SUCCESS,
  POST_HOMESALE_INFO_FAILURE,
  POST_HOMESALE_INFO_REQUEST,
  POST_HOMESALE_INFO_SUCCESS,
  POST_HOMESALE_RESALE_OFFER_FAILURE,
  POST_HOMESALE_RESALE_OFFER_REQUEST,
  POST_HOMESALE_RESALE_OFFER_SUCCESS,
  POST_INSPECTIONS_FAILURE,
  POST_INSPECTIONS_REQUEST,
  POST_INSPECTIONS_SUCCESS,
  POST_INSPECTORS_FAILURE,
  POST_INSPECTORS_REQUEST,
  POST_INSPECTORS_SUCCESS,
  POST_INTERN_SERVICES_FAILURE,
  POST_INTERN_SERVICES_REQUEST,
  POST_INTERN_SERVICES_SUCCESS,
  POST_LISTINGS_FAILURE,
  POST_LISTINGS_REQUEST,
  POST_LISTINGS_SUCCESS,
  POST_SO_INFO_FAILURE,
  POST_SO_INFO_REQUEST,
  POST_SO_INFO_SUCCESS,
  POST_TAX_FAILURE,
  POST_TAX_POLICY_FAILURE,
  POST_TAX_POLICY_REQUEST,
  POST_TAX_POLICY_SUCCESS,
  POST_TAX_REQUEST,
  POST_TAX_SUCCESS,
  POST_TEMPORARY_LIVING_ASSIGNMENT_FAILURE,
  POST_TEMPORARY_LIVING_ASSIGNMENT_REQUEST,
  POST_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
  POST_TITLE_REP_FAILURE,
  POST_TITLE_REP_REQUEST,
  POST_TITLE_REP_SUCCESS,
  POST_USER_SETTINGS_FAILURE,
  POST_USER_SETTINGS_REQUEST,
  POST_USER_SETTINGS_SUCCESS,
  POST_VENDORS_FAILURE,
  POST_VENDORS_REQUEST,
  POST_VENDORS_SUCCESS,
  POST_VENDOR_CONTACT_FAILURE,
  POST_VENDOR_CONTACT_REQUEST,
  POST_VENDOR_CONTACT_SUCCESS,
  SET_AUTH_ID,
  SET_LOADING_COMPLETE,
  SET_SELECTED_TEMPORARY_LIVING_ASSIGNMENT,
  UPDATE_APPRAISALS_FAILURE,
  UPDATE_APPRAISALS_REQUEST,
  UPDATE_APPRAISALS_SUCCESS,
  UPDATE_ASSIGNMENT_EXTENSIONS_FAILURE,
  UPDATE_ASSIGNMENT_EXTENSIONS_REQUEST,
  UPDATE_ASSIGNMENT_EXTENSIONS_SUCCESS,
  UPDATE_AUTHORIZATIONS_FAILURE,
  UPDATE_AUTHORIZATIONS_REQUEST,
  UPDATE_AUTHORIZATIONS_SUCCESS,
  UPDATE_AUTH_CLIENT_POLICIES_FAILURE,
  UPDATE_AUTH_CLIENT_POLICIES_REQUEST,
  UPDATE_AUTH_CLIENT_POLICIES_SUCCESS,
  UPDATE_AUTH_DATE_SUMMARY_FAILURE,
  UPDATE_AUTH_DATE_SUMMARY_REQUEST,
  UPDATE_AUTH_DATE_SUMMARY_SUCCESS,
  UPDATE_AUTH_DESTINATION_SERVICES_FAILURE,
  UPDATE_AUTH_DESTINATION_SERVICES_REQUEST,
  UPDATE_AUTH_DESTINATION_SERVICES_SUCCESS,
  UPDATE_AUTH_HOUSE_HUNTING_LIST_FAILURE,
  UPDATE_AUTH_HOUSE_HUNTING_LIST_REQUEST,
  UPDATE_AUTH_HOUSE_HUNTING_LIST_SUCCESS,
  UPDATE_AUTH_LIST_CLIENT_POLICIES_FAILURE,
  UPDATE_AUTH_LIST_CLIENT_POLICIES_REQUEST,
  UPDATE_AUTH_LIST_CLIENT_POLICIES_SUCCESS,
  UPDATE_AUTH_OFFER_HISTORY_LIST_FAILURE,
  UPDATE_AUTH_OFFER_HISTORY_LIST_REQUEST,
  UPDATE_AUTH_OFFER_HISTORY_LIST_SUCCESS,
  UPDATE_AUTH_SERVICES_FAILURE,
  UPDATE_AUTH_SERVICES_REQUEST,
  UPDATE_AUTH_SERVICES_SUCCESS,
  UPDATE_AUTH_TAX_ASSISTANCE_FAILURE,
  UPDATE_AUTH_TAX_ASSISTANCE_REQUEST,
  UPDATE_AUTH_TAX_ASSISTANCE_SUCCESS,
  UPDATE_AUTH_TEAM_FAILURE,
  UPDATE_AUTH_TEAM_REQUEST,
  UPDATE_AUTH_TEAM_SUCCESS,
  UPDATE_BROKER_AGENTS_FAILURE,
  UPDATE_BROKER_AGENTS_REQUEST,
  UPDATE_BROKER_AGENTS_SUCCESS,
  UPDATE_CANDIDATE_SERVICES_FAILURE,
  UPDATE_CANDIDATE_SERVICES_REQUEST,
  UPDATE_CANDIDATE_SERVICES_SUCCESS,
  UPDATE_COMMUNICATION_INFO_FAILURE,
  UPDATE_COMMUNICATION_INFO_REQUEST,
  UPDATE_COMMUNICATION_INFO_SUCCESS,
  UPDATE_COST_ESTIMATES_FAILURE,
  UPDATE_COST_ESTIMATES_REQUEST,
  UPDATE_COST_ESTIMATES_SUCCESS,
  UPDATE_CREDIT_FAILURE,
  UPDATE_CREDIT_REQUEST,
  UPDATE_CREDIT_SUCCESS,
  UPDATE_DEPARTURE_ADDRESS_FAILURE,
  UPDATE_DEPARTURE_ADDRESS_REQUEST,
  UPDATE_DEPARTURE_ADDRESS_SUCCESS,
  UPDATE_DESTINATION_ADDRESS_FAILURE,
  UPDATE_DESTINATION_ADDRESS_REQUEST,
  UPDATE_DESTINATION_ADDRESS_SUCCESS,
  UPDATE_EMPLOYEE_INFO_FAILURE,
  UPDATE_EMPLOYEE_INFO_REQUEST,
  UPDATE_EMPLOYEE_INFO_SUCCESS,
  UPDATE_EQUITY_FAILURE,
  UPDATE_EQUITY_REQUEST,
  UPDATE_EQUITY_SUCCESS,
  UPDATE_EXPENSE_CODES_FAILURE,
  UPDATE_EXPENSE_CODES_REQUEST,
  UPDATE_EXPENSE_CODES_SUCCESS,
  UPDATE_FAMILY_DATA,
  UPDATE_FAMILY_FAILURE,
  UPDATE_FAMILY_PET_DATA,
  UPDATE_FAMILY_PET_FAILURE,
  UPDATE_FAMILY_PET_REQUEST,
  UPDATE_FAMILY_PET_SUCCESS,
  UPDATE_FAMILY_REQUEST,
  UPDATE_FAMILY_SUCCESS,
  UPDATE_GLOBAL_DESTINATION_SERVICES_FAILURE,
  UPDATE_GLOBAL_DESTINATION_SERVICES_REQUEST,
  UPDATE_GLOBAL_DESTINATION_SERVICES_SUCCESS,
  UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE,
  UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST,
  UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS,
  UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_FAILURE,
  UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_REQUEST,
  UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_SUCCESS,
  UPDATE_GLOBAL_INFO_FAILURE,
  UPDATE_GLOBAL_INFO_REQUEST,
  UPDATE_GLOBAL_INFO_SUCCESS,
  UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE,
  UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST,
  UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
  UPDATE_GLOBAL_LANGUAGE_TRAINING_FAILURE,
  UPDATE_GLOBAL_LANGUAGE_TRAINING_REQUEST,
  UPDATE_GLOBAL_LANGUAGE_TRAINING_SUCCESS,
  UPDATE_HHG_ITEMS_FAILURE,
  UPDATE_HHG_ITEMS_REQUEST,
  UPDATE_HHG_ITEMS_SUCCESS,
  UPDATE_HHG_MOVING_DATE_FAILURE,
  UPDATE_HHG_MOVING_DATE_REQUEST,
  UPDATE_HHG_MOVING_DATE_SUCCESS,
  UPDATE_HHG_SEGMENT_FAILURE,
  UPDATE_HHG_SEGMENT_REQUEST,
  UPDATE_HHG_SEGMENT_SUCCESS,
  UPDATE_HOMESALE_INFO_FAILURE,
  UPDATE_HOMESALE_INFO_REQUEST,
  UPDATE_HOMESALE_INFO_SUCCESS,
  UPDATE_HOMESALE_RESALE_OFFER_FAILURE,
  UPDATE_HOMESALE_RESALE_OFFER_REQUEST,
  UPDATE_HOMESALE_RESALE_OFFER_SUCCESS,
  UPDATE_INSPECTIONS_FAILURE,
  UPDATE_INSPECTIONS_REQUEST,
  UPDATE_INSPECTIONS_STATE,
  UPDATE_INSPECTIONS_SUCCESS,
  UPDATE_INSPECTORS_FAILURE,
  UPDATE_INSPECTORS_REQUEST,
  UPDATE_INTERN_SERVICES_FAILURE,
  UPDATE_INTERN_SERVICES_REQUEST,
  UPDATE_INTERN_SERVICES_SUCCESS,
  UPDATE_LISTINGS_FAILURE,
  UPDATE_LISTINGS_REQUEST,
  UPDATE_LISTINGS_SUCCESS,
  UPDATE_SO_INFO_FAILURE,
  UPDATE_SO_INFO_REQUEST,
  UPDATE_SO_INFO_SUCCESS,
  UPDATE_TAX_FAILURE,
  UPDATE_TAX_POLICY_FAILURE,
  UPDATE_TAX_POLICY_REQUEST,
  UPDATE_TAX_POLICY_SUCCESS,
  UPDATE_TAX_REQUEST,
  UPDATE_TAX_SUCCESS,
  UPDATE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE,
  UPDATE_TEMPORARY_LIVING_ASSIGNMENT_REQUEST,
  UPDATE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
  UPDATE_TITLE_REP_FAILURE,
  UPDATE_TITLE_REP_REQUEST,
  UPDATE_TITLE_REP_SUCCESS,
  UPDATE_USER_SETTINGS_FAILURE,
  UPDATE_USER_SETTINGS_REQUEST,
  UPDATE_USER_SETTINGS_SUCCESS,
  UPDATE_VENDORS_FAILURE,
  UPDATE_VENDORS_REQUEST,
  UPDATE_VENDORS_SUCCESS,
  UPDATE_VENDOR_CONTACT_FAILURE,
  UPDATE_VENDOR_CONTACT_REQUEST,
  UPDATE_VENDOR_CONTACT_SUCCESS,
  GET_ALL_BUYER_TRIPS_FAILURE,
  GET_ALL_BUYER_TRIPS_REQUEST,
  GET_ALL_BUYER_TRIPS_SUCCESS,
  GET_ALL_RENTER_TRIPS_FAILURE,
  GET_ALL_RENTER_TRIPS_REQUEST,
  GET_ALL_RENTER_TRIPS_SUCCESS,
  GET_ALL_TEMP_LIVING_TRIPS_FAILURE,
  GET_ALL_TEMP_LIVING_TRIPS_REQUEST,
  GET_ALL_TEMP_LIVING_TRIPS_SUCCESS,
  GET_BUYER_TRIP_FAILURE,
  GET_BUYER_TRIP_REQUEST,
  GET_BUYER_TRIP_SUCCESS,
  GET_RENTER_TRIP_FAILURE,
  GET_RENTER_TRIP_REQUEST,
  GET_RENTER_TRIP_SUCCESS,
  GET_TEMP_LIVING_TRIP_FAILURE,
  GET_TEMP_LIVING_TRIP_REQUEST,
  GET_TEMP_LIVING_TRIP_SUCCESS,
  UPSERT_ASSIGNMENT_TRIPS_FAILURE,
  UPSERT_ASSIGNMENT_TRIPS_REQUEST,
  UPSERT_ASSIGNMENT_TRIPS_SUCCESS,
  UPSERT_BUYER_TRIP_FAILURE,
  UPSERT_BUYER_TRIP_REQUEST,
  UPSERT_BUYER_TRIP_SUCCESS,
  UPSERT_CANDIDATE_TRIP_FAILURE,
  UPSERT_CANDIDATE_TRIP_REQUEST,
  UPSERT_CANDIDATE_TRIP_SUCCESS,
  UPSERT_RENTER_TRIP_FAILURE,
  UPSERT_RENTER_TRIP_REQUEST,
  UPSERT_RENTER_TRIP_SUCCESS,
  UPSERT_TEMP_LIVING_TRIP_FAILURE,
  UPSERT_TEMP_LIVING_TRIP_REQUEST,
  UPSERT_TEMP_LIVING_TRIP_SUCCESS,
  DELETE_BUYER_TRIP_FAILURE,
  DELETE_BUYER_TRIP_REQUEST,
  DELETE_BUYER_TRIP_SUCCESS,
  DELETE_RENTER_TRIP_FAILURE,
  DELETE_RENTER_TRIP_REQUEST,
  DELETE_RENTER_TRIP_SUCCESS,
  DELETE_TEMP_LIVING_TRIP_FAILURE,
  DELETE_TEMP_LIVING_TRIP_REQUEST,
  DELETE_TEMP_LIVING_TRIP_SUCCESS,
  GET_ASSIGNMENT_TRIP_FAILURE,
  GET_ASSIGNMENT_TRIP_REQUEST,
  GET_ASSIGNMENT_TRIP_SUCCESS,
  POST_GLOBAL_ASSIGNMENT_FAILURE,
  POST_GLOBAL_ASSIGNMENT_REQUEST,
  POST_GLOBAL_ASSIGNMENT_SUCCESS,
  UPDATE_GLOBAL_ASSIGNMENT_FAILURE,
  UPDATE_GLOBAL_ASSIGNMENT_REQUEST,
  UPDATE_GLOBAL_ASSIGNMENT_SUCCESS,
  GET_GLOBAL_ASSIGNMENT_FAILURE,
  GET_GLOBAL_ASSIGNMENT_REQUEST,
  GET_GLOBAL_ASSIGNMENT_SUCCESS
} from './types';

import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';

export const getAuthorizationSummaries = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTHORIZATIONS_REQUEST, GET_AUTHORIZATIONS_SUCCESS, GET_AUTHORIZATIONS_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations',
      method: 'GET'
    }
  };
};

export const getAuthorizationSummary = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_SUMMARY_REQUEST, GET_AUTH_SUMMARY_SUCCESS, GET_AUTH_SUMMARY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}`,
      method: 'GET'
    }
  };
};

export const postAuthorizationSummary = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTHORIZATIONS_REQUEST, POST_AUTHORIZATIONS_SUCCESS, POST_AUTHORIZATIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAuthorizationSummary = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTHORIZATIONS_REQUEST, UPDATE_AUTHORIZATIONS_SUCCESS, UPDATE_AUTHORIZATIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteAuthorizationSummary = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTHORIZATIONS_REQUEST, DELETE_AUTHORIZATIONS_SUCCESS, DELETE_AUTHORIZATIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}`,
      method: 'DELETE'
    }
  };
};

export const getEmployeeInfo = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_EMPLOYEE_INFO_REQUEST, GET_EMPLOYEE_INFO_SUCCESS, GET_EMPLOYEE_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/employee`,
      method: 'GET'
    }
  };
};

export const postEmployeeInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_EMPLOYEE_INFO_REQUEST, POST_EMPLOYEE_INFO_SUCCESS, POST_EMPLOYEE_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/employee/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateEmployeeInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_EMPLOYEE_INFO_REQUEST, UPDATE_EMPLOYEE_INFO_SUCCESS, UPDATE_EMPLOYEE_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/employee/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getSOInfo = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_SO_INFO_REQUEST, GET_SO_INFO_SUCCESS, GET_SO_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/significantOther`,
      method: 'GET'
    }
  };
};

export const postSOInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_SO_INFO_REQUEST, POST_SO_INFO_SUCCESS, POST_SO_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/significantOther/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateSOInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_SO_INFO_REQUEST, UPDATE_SO_INFO_SUCCESS, UPDATE_SO_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/significantOther/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getCommunicationInfo = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_COMMUNICATION_INFO_REQUEST, GET_COMMUNICATION_INFO_SUCCESS, GET_COMMUNICATION_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/communication`,
      method: 'GET'
    }
  };
};

export const postCommunicationInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_COMMUNICATION_INFO_REQUEST, POST_COMMUNICATION_INFO_SUCCESS, POST_COMMUNICATION_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/communication/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateCommunicationInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_COMMUNICATION_INFO_REQUEST, UPDATE_COMMUNICATION_INFO_SUCCESS, UPDATE_COMMUNICATION_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/communication/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const setLoadingComplete = () => ({
  type: SET_LOADING_COMPLETE
});

export const setAuthId = id => ({
  type: SET_AUTH_ID,
  response: id
});

export const getAuthDateSummary = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_DATE_SUMMARY_REQUEST, GET_AUTH_DATE_SUMMARY_SUCCESS, GET_AUTH_DATE_SUMMARY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/summary`,
      method: 'GET'
    }
  };
};

export const postAuthDateSummary = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_DATE_SUMMARY_REQUEST, POST_AUTH_DATE_SUMMARY_SUCCESS, POST_AUTH_DATE_SUMMARY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/summary/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAuthDateSummary = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_DATE_SUMMARY_REQUEST, UPDATE_AUTH_DATE_SUMMARY_SUCCESS, UPDATE_AUTH_DATE_SUMMARY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/summary/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getDepartureAddress = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_DEPARTURE_ADDRESS_REQUEST, GET_DEPARTURE_ADDRESS_SUCCESS, GET_DEPARTURE_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/departure`,
      method: 'GET'
    }
  };
};

export const postDepartureAddress = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_DEPARTURE_ADDRESS_REQUEST, POST_DEPARTURE_ADDRESS_SUCCESS, POST_DEPARTURE_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/departure/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateDepartureAddress = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_DEPARTURE_ADDRESS_REQUEST, UPDATE_DEPARTURE_ADDRESS_SUCCESS, UPDATE_DEPARTURE_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/departure/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getDestinationAddress = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_DESTINATION_ADDRESS_REQUEST, GET_DESTINATION_ADDRESS_SUCCESS, GET_DESTINATION_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/destination`,
      method: 'GET'
    }
  };
};

export const postDestinationAddress = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_DESTINATION_ADDRESS_REQUEST, POST_DESTINATION_ADDRESS_SUCCESS, POST_DESTINATION_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/destination/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateDestinationAddress = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_DESTINATION_ADDRESS_REQUEST, UPDATE_DESTINATION_ADDRESS_SUCCESS, UPDATE_DESTINATION_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/destination/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getAuthClientPolicies = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_CLIENT_POLICIES_REQUEST, GET_AUTH_CLIENT_POLICIES_SUCCESS, GET_AUTH_CLIENT_POLICIES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/clientPolicy`,
      method: 'GET'
    }
  };
};

export const postAuthClientPolicies = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_CLIENT_POLICIES_REQUEST, POST_AUTH_CLIENT_POLICIES_SUCCESS, POST_AUTH_CLIENT_POLICIES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/clientPolicy/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAuthClientPolicies = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_CLIENT_POLICIES_REQUEST, UPDATE_AUTH_CLIENT_POLICIES_SUCCESS, UPDATE_AUTH_CLIENT_POLICIES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/clientPolicy/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

/* Team calls */
export const getTeam = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_TEAM_REQUEST, GET_AUTH_TEAM_SUCCESS, GET_AUTH_TEAM_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/team`,
      method: 'GET'
    }
  };
};

export const postTeam = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_TEAM_REQUEST, POST_AUTH_TEAM_SUCCESS, POST_AUTH_TEAM_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/team/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateTeam = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_TEAM_REQUEST, UPDATE_AUTH_TEAM_SUCCESS, UPDATE_AUTH_TEAM_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/team/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

/* Services calls */

export const getAuthServices = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_AUTH_SERVICES_REQUEST, GET_ALL_AUTH_SERVICES_SUCCESS, GET_ALL_AUTH_SERVICES_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/authService',
      method: 'GET'
    }
  };
};

export const getServices = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_SERVICES_REQUEST, GET_AUTH_SERVICES_SUCCESS, GET_AUTH_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/authService`,
      method: 'GET'
    }
  };
};

export const postServices = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_SERVICES_REQUEST, POST_AUTH_SERVICES_SUCCESS, POST_AUTH_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/authService/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateServices = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_SERVICES_REQUEST, UPDATE_AUTH_SERVICES_SUCCESS, UPDATE_AUTH_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/authService/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteServices = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTH_SERVICES_REQUEST, DELETE_AUTH_SERVICES_SUCCESS, DELETE_AUTH_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/authService`,
      method: 'DELETE'
    }
  };
};

export const getAuthClientPoliciesListByClient = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_REQUEST,
        GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_SUCCESS,
        GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_FAILURE
      ],
      authenticated: true,
      endpoint: `api/ClientPolicys/GetByClientId/${id}`,
      method: 'GET'
    }
  };
};

export const getAuthClientPoliciesList = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_LIST_CLIENT_POLICIES_REQUEST, GET_AUTH_LIST_CLIENT_POLICIES_SUCCESS, GET_AUTH_LIST_CLIENT_POLICIES_FAILURE],
      authenticated: true,
      endpoint: 'api/ClientPolicys',
      method: 'GET'
    }
  };
};

export const postAuthClientPoliciesList = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_LIST_CLIENT_POLICIES_REQUEST, POST_AUTH_LIST_CLIENT_POLICIES_SUCCESS, POST_AUTH_LIST_CLIENT_POLICIES_FAILURE],
      authenticated: true,
      endpoint: `api/ClientPolicys/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAuthClientPoliciesList = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_LIST_CLIENT_POLICIES_REQUEST, UPDATE_AUTH_LIST_CLIENT_POLICIES_SUCCESS, UPDATE_AUTH_LIST_CLIENT_POLICIES_FAILURE],
      authenticated: true,
      endpoint: `api/ClientPolicys/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteAuthClientPoliciesList = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTH_LIST_CLIENT_POLICIES_REQUEST, DELETE_AUTH_LIST_CLIENT_POLICIES_SUCCESS, DELETE_AUTH_LIST_CLIENT_POLICIES_FAILURE],
      authenticated: true,
      endpoint: `api/ClientsPolicys/${id}`,
      method: 'DELETE'
    }
  };
};

export const getAuthActivityLog = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ACTIVITY_LOG_REQUEST, GET_ACTIVITY_LOG_SUCCESS, GET_ACTIVITY_LOG_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/logs`,
      method: 'GET'
    }
  };
};

export const getUserSettings = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_USER_SETTINGS_REQUEST, GET_USER_SETTINGS_SUCCESS, GET_USER_SETTINGS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/userSetting`,
      method: 'GET'
    }
  };
};

export const postUserSettings = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_USER_SETTINGS_REQUEST, POST_USER_SETTINGS_SUCCESS, POST_USER_SETTINGS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/userSetting/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateUserSettings = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_USER_SETTINGS_REQUEST, UPDATE_USER_SETTINGS_SUCCESS, UPDATE_USER_SETTINGS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/userSetting/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

/* Tax Policies Calls */

export const getTaxPolicies = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_TAX_POLICIES_REQUEST, GET_TAX_POLICIES_SUCCESS, GET_TAX_POLICIES_FAILURE],
      authenticated: true,
      endpoint: 'api/TaxPolicys',
      method: 'GET'
    }
  };
};

export const getTaxPoliciesByClientId = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_TAX_POLICIES_BY_CLIENT_REQUEST, GET_TAX_POLICIES_BY_CLIENT_SUCCESS, GET_TAX_POLICIES_BY_CLIENT_FAILURE],
      authenticated: true,
      endpoint: `api/TaxPolicys/GetByClientId/${id}`,
      method: 'GET'
    }
  };
};

export const postTaxPolicy = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_TAX_POLICY_REQUEST, POST_TAX_POLICY_SUCCESS, POST_TAX_POLICY_FAILURE],
      authenticated: true,
      endpoint: 'api/TaxPolicys',
      method: 'POST',
      payload: values
    }
  };
};

export const updateTaxPolicy = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_TAX_POLICY_REQUEST, UPDATE_TAX_POLICY_SUCCESS, UPDATE_TAX_POLICY_FAILURE],
      authenticated: true,
      endpoint: 'api/TaxPolicys',
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteTaxPolicy = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_TAX_POLICY_REQUEST, DELETE_TAX_POLICY_SUCCESS, DELETE_TAX_POLICY_FAILURE],
      authenticated: true,
      endpoint: `api/TaxPolicys/${id}`,
      method: 'DELETE'
    }
  };
};

/* Tax Assistance Calls */
export const getAuthTaxAssistance = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_TAX_ASSISTANCE_REQUEST, GET_AUTH_TAX_ASSISTANCE_SUCCESS, GET_AUTH_TAX_ASSISTANCE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/taxassistance`,
      method: 'GET'
    }
  };
};

export const postAuthTaxAssistance = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_TAX_ASSISTANCE_REQUEST, POST_AUTH_TAX_ASSISTANCE_SUCCESS, POST_AUTH_TAX_ASSISTANCE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/taxassistance/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAuthTaxAssistance = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_TAX_ASSISTANCE_REQUEST, UPDATE_AUTH_TAX_ASSISTANCE_SUCCESS, UPDATE_AUTH_TAX_ASSISTANCE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/taxassistance/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

/* Destination Services Calls */
export const getAuthDestinationServices = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_DESTINATION_SERVICES_REQUEST, GET_AUTH_DESTINATION_SERVICES_SUCCESS, GET_AUTH_DESTINATION_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/destinationService`,
      method: 'GET'
    }
  };
};

export const postAuthDestinationServices = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        POST_AUTH_DESTINATION_SERVICES_REQUEST,
        POST_AUTH_DESTINATION_SERVICES_SUCCESS,
        'we need to delete the file share references'
      ],
      authenticated: true,
      endpoint: `api/authorizations/destinationService/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAuthDestinationServices = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_DESTINATION_SERVICES_REQUEST, UPDATE_AUTH_DESTINATION_SERVICES_SUCCESS, UPDATE_AUTH_DESTINATION_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/destinationService/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

/* Broker/Agent endpoints */

export const getBrokerAgents = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_BROKER_AGENTS_REQUEST, GET_ALL_BROKER_AGENTS_SUCCESS, GET_ALL_BROKER_AGENTS_FAILURE],
      authenticated: true,
      endpoint: 'api/common/agents',
      method: 'GET'
    }
  };
};

export const getBrokerAgentsById = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_BROKER_AGENTS_BY_ID_REQUEST, GET_BROKER_AGENTS_BY_ID_SUCCESS, GET_BROKER_AGENTS_BY_ID_FAILURE],
      authenticated: true,
      endpoint: `api/BrokerAgents/${id}`,
      method: 'GET'
    }
  };
};

export const postBrokerAgents = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_BROKER_AGENTS_REQUEST, POST_BROKER_AGENTS_SUCCESS, POST_BROKER_AGENTS_FAILURE],
      authenticated: true,
      endpoint: 'api/BrokerAgents/',
      method: 'POST',
      payload: values
    }
  };
};

export const updateBrokerAgents = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_BROKER_AGENTS_REQUEST, UPDATE_BROKER_AGENTS_SUCCESS, UPDATE_BROKER_AGENTS_FAILURE],
      authenticated: true,
      endpoint: 'api/BrokerAgents/',
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteBrokerAgents = brokerAgentId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_BROKER_AGENTS_REQUEST, DELETE_BROKER_AGENTS_SUCCESS, DELETE_BROKER_AGENTS_FAILURE],
      authenticated: true,
      endpoint: `api/BrokerAgents/${brokerAgentId}`,
      method: 'DELETE'
    }
  };
};

export const getAuthPets = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_PETS_REQUEST, GET_AUTH_PETS_SUCCESS, GET_AUTH_PETS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/pets`,
      method: 'GET'
    }
  };
};

export const postAuthPets = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_PETS_REQUEST, POST_AUTH_PETS_SUCCESS, POST_AUTH_PETS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/pets/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const getTemporaryLivingAssignments = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_TEMPORARY_LIVING_ASSIGNMENT_REQUEST, GET_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS, GET_TEMPORARY_LIVING_ASSIGNMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/tempLiving`,
      method: 'GET'
    }
  };
};

export const postTemporaryLivingAssignments = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_TEMPORARY_LIVING_ASSIGNMENT_REQUEST, POST_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS, POST_TEMPORARY_LIVING_ASSIGNMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/tempLiving/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateTemporaryLivingAssignments = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        UPDATE_TEMPORARY_LIVING_ASSIGNMENT_REQUEST,
        UPDATE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
        UPDATE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/tempLiving/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteTemporaryLivingAssignment = (authorizationId, temporaryLivingId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        DELETE_TEMPORARY_LIVING_ASSIGNMENT_REQUEST,
        DELETE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
        DELETE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authorizationId}/tempLiving/${temporaryLivingId}`,
      method: 'DELETE'
    }
  };
};

export const setSelectTemporaryLivingAssignment = tempLivingAssignment => ({
  type: SET_SELECTED_TEMPORARY_LIVING_ASSIGNMENT,
  response: tempLivingAssignment
});

/* HHG Requests */

export const getHhgSegments = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_HHG_SEGMENTS_REQUEST, GET_HHG_SEGMENTS_SUCCESS, GET_HHG_SEGMENTS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/hhg`,
      method: 'GET'
    }
  };
};

export const postHhgSegment = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_HHG_SEGMENT_REQUEST, POST_HHG_SEGMENT_SUCCESS, POST_HHG_SEGMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/hhg/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateHhgSegment = values => {
  // const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_HHG_SEGMENT_REQUEST, UPDATE_HHG_SEGMENT_SUCCESS, UPDATE_HHG_SEGMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/hhg`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getHhgMovingDates = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_HHG_MOVING_DATE_REQUEST, GET_HHG_MOVING_DATE_SUCCESS, GET_HHG_MOVING_DATE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/hhgMovingDate`,
      method: 'GET'
    }
  };
};

export const postHhgMovingDate = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_HHG_MOVING_DATE_REQUEST, POST_HHG_MOVING_DATE_SUCCESS, POST_HHG_MOVING_DATE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/hhgMovingDate/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateHhgMovingDate = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_HHG_MOVING_DATE_REQUEST, UPDATE_HHG_MOVING_DATE_SUCCESS, UPDATE_HHG_MOVING_DATE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/hhgMovingDate/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteHhgMovingDate = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_HHG_MOVING_DATE_REQUEST, DELETE_HHG_MOVING_DATE_SUCCESS, DELETE_HHG_MOVING_DATE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/hhgMovingDate`,
      method: 'DELETE'
    }
  };
};

export const getHouseHuntingList = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_HOUSE_HUNTING_LIST_REQUEST, GET_AUTH_HOUSE_HUNTING_LIST_SUCCESS, GET_AUTH_HOUSE_HUNTING_LIST_FAILURE],
      authenticated: true,
      endpoint: `api/HouseHunting/GetByClientId/${id}`,
      method: 'GET'
    }
  };
};

export const postHouseHuntingList = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_HOUSE_HUNTING_LIST_REQUEST, POST_AUTH_HOUSE_HUNTING_LIST_SUCCESS, POST_AUTH_HOUSE_HUNTING_LIST_FAILURE],
      authenticated: true,
      endpoint: 'api/HouseHunting/',
      method: 'POST',
      payload: values
    }
  };
};

export const updateHouseHuntingList = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_HOUSE_HUNTING_LIST_REQUEST, UPDATE_AUTH_HOUSE_HUNTING_LIST_SUCCESS, UPDATE_AUTH_HOUSE_HUNTING_LIST_FAILURE],
      authenticated: true,
      endpoint: 'api/HouseHunting/',
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteHouseHuntingList = listItemId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTH_HOUSE_HUNTING_LIST_REQUEST, DELETE_AUTH_HOUSE_HUNTING_LIST_SUCCESS, DELETE_AUTH_HOUSE_HUNTING_LIST_FAILURE],
      authenticated: true,
      endpoint: `api/HouseHunting/${listItemId}`,
      method: 'DELETE'
    }
  };
};

export const getOfferHistoryList = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_OFFER_HISTORY_LIST_REQUEST, GET_AUTH_OFFER_HISTORY_LIST_SUCCESS, GET_AUTH_OFFER_HISTORY_LIST_FAILURE],
      authenticated: true,
      endpoint: `api/OfferHistory/GetByAuthorizationId/${id}`,
      method: 'GET'
    }
  };
};

export const postOfferHistoryList = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_OFFER_HISTORY_LIST_REQUEST, POST_AUTH_OFFER_HISTORY_LIST_SUCCESS, POST_AUTH_OFFER_HISTORY_LIST_FAILURE],
      authenticated: true,
      endpoint: 'api/OfferHistory/',
      method: 'POST',
      payload: values
    }
  };
};

export const updateOfferHistoryList = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_OFFER_HISTORY_LIST_REQUEST, UPDATE_AUTH_OFFER_HISTORY_LIST_SUCCESS, UPDATE_AUTH_OFFER_HISTORY_LIST_FAILURE],
      authenticated: true,
      endpoint: 'api/OfferHistory/',
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteOfferHistoryList = listItemId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTH_OFFER_HISTORY_LIST_REQUEST, DELETE_AUTH_OFFER_HISTORY_LIST_SUCCESS, DELETE_AUTH_OFFER_HISTORY_LIST_FAILURE],
      authenticated: true,
      endpoint: `api/OfferHistory/${listItemId}`,
      method: 'DELETE'
    }
  };
};

export const getHhgItems = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_HHG_ITEMS_REQUEST, GET_HHG_ITEMS_SUCCESS, GET_HHG_ITEMS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/hhgItem`,
      method: 'GET'
    }
  };
};

export const postHhgItems = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_HHG_ITEMS_REQUEST, POST_HHG_ITEMS_SUCCESS, POST_HHG_ITEMS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/hhgItem/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateHhgItems = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_HHG_ITEMS_REQUEST, UPDATE_HHG_ITEMS_SUCCESS, UPDATE_HHG_ITEMS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/hhgItem/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteHhgItems = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_HHG_ITEMS_REQUEST, DELETE_HHG_ITEMS_SUCCESS, DELETE_HHG_ITEMS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/hhgItem`,
      method: 'DELETE'
    }
  };
};

/* HHG Requests */

export const getHhgEstimates = segmentId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_HHG_ESTIMATES_REQUEST, GET_HHG_ESTIMATES_SUCCESS, GET_HHG_ESTIMATES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${segmentId}/hhgEstimate`,
      method: 'GET'
    }
  };
};

export const postHhgEstimate = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_HHG_ESTIMATE_REQUEST, POST_HHG_ESTIMATE_SUCCESS, POST_HHG_ESTIMATE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/hhgEstimate/${username}`,
      method: 'POST',
      payload: values
    }
  };
};
/* Vendor Requests */

export const getVendors = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VENDORS_REQUEST, GET_VENDORS_SUCCESS, GET_VENDORS_FAILURE],
      authenticated: true,
      endpoint: 'api/Vendors',
      method: 'GET'
    }
  };
};

export const postVendor = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_VENDORS_REQUEST, POST_VENDORS_SUCCESS, POST_VENDORS_FAILURE],
      authenticated: true,
      endpoint: 'api/Vendors',
      method: 'POST',
      payload: values
    }
  };
};

export const updateVendor = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_VENDORS_REQUEST, UPDATE_VENDORS_SUCCESS, UPDATE_VENDORS_FAILURE],
      authenticated: true,
      endpoint: 'api/Vendors',
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteVendor = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_VENDORS_REQUEST, DELETE_VENDORS_SUCCESS, DELETE_VENDORS_FAILURE],
      authenticated: true,
      endpoint: `api/Vendors/${id}`,
      method: 'DELETE'
    }
  };
};

export const getVendorContacts = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VENDOR_CONTACT_REQUEST, GET_VENDOR_CONTACT_SUCCESS, GET_VENDOR_CONTACT_FAILURE],
      authenticated: true,
      endpoint: 'api/Vendors/contacts',
      method: 'GET'
    }
  };
};

export const postVendorContact = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_VENDOR_CONTACT_REQUEST, POST_VENDOR_CONTACT_SUCCESS, POST_VENDOR_CONTACT_FAILURE],
      authenticated: true,
      endpoint: 'api/Vendors/contacts',
      method: 'POST',
      payload: values
    }
  };
};

export const updateVendorContact = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_VENDOR_CONTACT_REQUEST, UPDATE_VENDOR_CONTACT_SUCCESS, UPDATE_VENDOR_CONTACT_FAILURE],
      authenticated: true,
      endpoint: 'api/Vendors/contacts',
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteVendorContact = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_VENDOR_CONTACT_REQUEST, DELETE_VENDOR_CONTACT_SUCCESS, DELETE_VENDOR_CONTACT_FAILURE],
      authenticated: true,
      endpoint: `api/Vendors/contacts/${id}`,
      method: 'DELETE'
    }
  };
};

/* Global Requests */

export const getGlobalInfo = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_GLOBAL_INFO_REQUEST, GET_GLOBAL_INFO_SUCCESS, GET_GLOBAL_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/global`,
      method: 'GET'
    }
  };
};

export const postGlobalInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_GLOBAL_INFO_REQUEST, POST_GLOBAL_INFO_SUCCESS, POST_GLOBAL_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/global/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateGlobalInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_GLOBAL_INFO_REQUEST, UPDATE_GLOBAL_INFO_SUCCESS, UPDATE_GLOBAL_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/global/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getGlobalAssignment = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_GLOBAL_ASSIGNMENT_REQUEST, GET_GLOBAL_ASSIGNMENT_SUCCESS, GET_GLOBAL_ASSIGNMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/globalAssignment/${authId}`,
      method: 'GET'
    }
  };
};

export const postGlobalAssignment = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_GLOBAL_ASSIGNMENT_REQUEST, POST_GLOBAL_ASSIGNMENT_SUCCESS, POST_GLOBAL_ASSIGNMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/globalAssignment`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateGlobalAssignment = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_GLOBAL_ASSIGNMENT_REQUEST, UPDATE_GLOBAL_ASSIGNMENT_SUCCESS, UPDATE_GLOBAL_ASSIGNMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/globalAssignment`,
      method: 'PUT',
      payload: values
    }
  };
};

export const updateGlobalDestinationServices = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        UPDATE_GLOBAL_DESTINATION_SERVICES_REQUEST,
        UPDATE_GLOBAL_DESTINATION_SERVICES_SUCCESS,
        UPDATE_GLOBAL_DESTINATION_SERVICES_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/globalDestServices/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getAssignmentTrips = serviceId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ASSIGNMENT_TRIPS_REQUEST, GET_ASSIGNMENT_TRIPS_SUCCESS, GET_ASSIGNMENT_TRIPS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${serviceId}/globalTrips`,
      method: 'GET'
    }
  };
};

export const getAssignmentTrip = tripId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ASSIGNMENT_TRIP_REQUEST, GET_ASSIGNMENT_TRIP_SUCCESS, GET_ASSIGNMENT_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${tripId}/globalTrips`,
      method: 'GET'
    }
  };
};

export const upsertAssignmentTrip = (serviceId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPSERT_ASSIGNMENT_TRIPS_REQUEST, UPSERT_ASSIGNMENT_TRIPS_SUCCESS, UPSERT_ASSIGNMENT_TRIPS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/globalTrips/${serviceId}`,
      method: 'POST',
      payload: values,
      context: serviceId
    }
  };
};

export const deleteAssignmentTrip = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_ASSIGNMENT_TRIPS_REQUEST, DELETE_ASSIGNMENT_TRIPS_SUCCESS, DELETE_ASSIGNMENT_TRIPS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/globalTrips`,
      method: 'DELETE'
    }
  };
};

export const getAssignmentExtensions = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ASSIGNMENT_EXTENSIONS_REQUEST, GET_ASSIGNMENT_EXTENSIONS_SUCCESS, GET_ASSIGNMENT_EXTENSIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/globalExtensions`,
      method: 'GET'
    }
  };
};

export const postAssignmentExtension = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_ASSIGNMENT_EXTENSIONS_REQUEST, POST_ASSIGNMENT_EXTENSIONS_SUCCESS, POST_ASSIGNMENT_EXTENSIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/globalExtensions/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAssignmentExtension = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_ASSIGNMENT_EXTENSIONS_REQUEST, UPDATE_ASSIGNMENT_EXTENSIONS_SUCCESS, UPDATE_ASSIGNMENT_EXTENSIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/globalExtensions/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteAssignmentExtension = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_ASSIGNMENT_EXTENSIONS_REQUEST, DELETE_ASSIGNMENT_EXTENSIONS_SUCCESS, DELETE_ASSIGNMENT_EXTENSIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/globalExtensions`,
      method: 'DELETE'
    }
  };
};

export const deleteGlobalLanguageTraining = (authId, id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_GLOBAL_LANGUAGE_TRAINING_REQUEST, DELETE_GLOBAL_LANGUAGE_TRAINING_SUCCESS, DELETE_GLOBAL_LANGUAGE_TRAINING_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/globalLanguageTraining/${id}`,
      method: 'DELETE'
    }
  };
};

export const getGlobalInternationalSchooling = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST,
        GET_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
        GET_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/globalInternationSchooling`,
      method: 'GET'
    }
  };
};

export const postGlobalInternationalSchooling = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        POST_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST,
        POST_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
        POST_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/globalInternationSchooling/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateGlobalInternationalSchooling = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST,
        UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
        UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/globalInternationSchooling/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteGlobalInternationalSchooling = (authId, id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST,
        DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
        DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/globalInternationSchooling/${id}`,
      method: 'DELETE'
    }
  };
};

export const deleteGlobalDestinationServices = (authId, id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        DELETE_GLOBAL_DESTINATION_SERVICES_REQUEST,
        DELETE_GLOBAL_DESTINATION_SERVICES_SUCCESS,
        DELETE_GLOBAL_DESTINATION_SERVICES_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/globalDestServices/${id}`,
      method: 'DELETE'
    }
  };
};

export const getGlobalDestinationServices = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_GLOBAL_DESTINATION_SERVICES_REQUEST, GET_GLOBAL_DESTINATION_SERVICES_SUCCESS, GET_GLOBAL_DESTINATION_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/globalDestServices`,
      method: 'GET'
    }
  };
};

export const postGlobalDestinationServices = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_GLOBAL_DESTINATION_SERVICES_REQUEST, POST_GLOBAL_DESTINATION_SERVICES_SUCCESS, POST_GLOBAL_DESTINATION_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/globalDestServices/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const getGlobalLanguageTraining = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_GLOBAL_LANGUAGE_TRAINING_REQUEST, GET_GLOBAL_LANGUAGE_TRAINING_SUCCESS, GET_GLOBAL_LANGUAGE_TRAINING_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/globalLanguageTraining`,
      method: 'GET'
    }
  };
};

export const postGlobalLanguageTraining = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_GLOBAL_LANGUAGE_TRAINING_REQUEST, POST_GLOBAL_LANGUAGE_TRAINING_SUCCESS, POST_GLOBAL_LANGUAGE_TRAINING_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/globalLanguageTraining/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateGlobalLanguageTraining = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_GLOBAL_LANGUAGE_TRAINING_REQUEST, UPDATE_GLOBAL_LANGUAGE_TRAINING_SUCCESS, UPDATE_GLOBAL_LANGUAGE_TRAINING_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/globalLanguageTraining/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getGlobalHomeServiceProperties = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST,
        GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS,
        GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/globalHomeService/${id}`,
      method: 'GET'
    }
  };
};

export const getGlobalHomeServiceProperty = propertyId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST, GET_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS, GET_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/globalHomeService/getById/${propertyId}`,
      method: 'GET'
    }
  };
};

export const postGlobalHomeServiceProperty = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        POST_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST,
        POST_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS,
        POST_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE
      ],
      authenticated: true,
      endpoint: 'api/authorizations/globalHomeService',
      method: 'POST',
      payload: values
    }
  };
};

export const updateGlobalHomeServiceProperty = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST,
        UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS,
        UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE
      ],
      authenticated: true,
      endpoint: 'api/authorizations/globalHomeService',
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteGlobalHomeServiceProperty = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        DELETE_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST,
        DELETE_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS,
        DELETE_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/globalHomeService/${id}`,
      method: 'DELETE'
    }
  };
};

export const getAllGlobalHomeServicePropertyTenants = propertyId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_TENANTS_REQUEST,
        GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_TENANTS_SUCCESS,
        GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_TENANTS_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/globalHomeService/tenant/${propertyId}`,
      method: 'GET'
    }
  };
};

export const getGlobalHomeServicePropertyTenant = tenantId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_REQUEST,
        GET_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_SUCCESS,
        GET_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/globalHomeService/tenant/${tenantId}`,
      method: 'GET'
    }
  };
};

export const postGlobalHomeServicePropertyTenant = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        POST_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_REQUEST,
        POST_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_SUCCESS,
        POST_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_FAILURE
      ],
      authenticated: true,
      endpoint: 'api/authorizations/globalHomeService/tenant',
      method: 'POST',
      payload: values
    }
  };
};

export const updateGlobalHomeServicePropertyTenant = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_REQUEST,
        UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_SUCCESS,
        UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_FAILURE
      ],
      authenticated: true,
      endpoint: 'api/authorizations/globalHomeService/tenant',
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteGlobalHomeServicePropertyTenant = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        DELETE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_REQUEST,
        DELETE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_SUCCESS,
        DELETE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/globalHomeService/tenant/${id}`,
      method: 'DELETE'
    }
  };
};

export const getFamilyMembers = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_FAMILY_REQUEST, GET_FAMILY_SUCCESS, GET_FAMILY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/family`,
      method: 'GET'
    }
  };
};

export const postFamilyMember = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_FAMILY_REQUEST, POST_FAMILY_SUCCESS, POST_FAMILY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/family/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateFamilyMember = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_FAMILY_REQUEST, UPDATE_FAMILY_SUCCESS, UPDATE_FAMILY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/family/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteFamilyMember = (authId, id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_FAMILY_REQUEST, DELETE_FAMILY_SUCCESS, DELETE_FAMILY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/family/${id}`,
      method: 'DELETE'
    }
  };
};

/* Homesale Requests */

export const getHomesaleInfo = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_HOMESALE_INFO_REQUEST, GET_HOMESALE_INFO_SUCCESS, GET_HOMESALE_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/homesale`,
      method: 'GET'
    }
  };
};

export const postHomesaleInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_HOMESALE_INFO_REQUEST, POST_HOMESALE_INFO_SUCCESS, POST_HOMESALE_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/homesale/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateHomesaleInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_HOMESALE_INFO_REQUEST, UPDATE_HOMESALE_INFO_SUCCESS, UPDATE_HOMESALE_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/homesale/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const updateFamilyMembersState = family => {
  return {
    type: UPDATE_FAMILY_DATA,
    response: family
  };
};

export const getFamilyPets = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_FAMILY_PET_REQUEST, GET_FAMILY_PET_SUCCESS, GET_FAMILY_PET_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/familyPet`,
      method: 'GET'
    }
  };
};

export const postFamilyPet = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_FAMILY_PET_REQUEST, POST_FAMILY_PET_SUCCESS, POST_FAMILY_PET_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/familyPet/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateFamilyPet = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_FAMILY_PET_REQUEST, UPDATE_FAMILY_PET_SUCCESS, UPDATE_FAMILY_PET_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/familyPet/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteFamilyPet = (authId, id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_FAMILY_PET_REQUEST, DELETE_FAMILY_PET_SUCCESS, DELETE_FAMILY_PET_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/familyPet/${id}`,
      method: 'DELETE'
    }
  };
};

export const updateFamilyPetsState = familyPets => {
  return {
    type: UPDATE_FAMILY_PET_DATA,
    response: familyPets
  };
};

/* Homesale - Appraisals Requests */

export const getAllAppraisals = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_APPRAISALS_REQUEST, GET_APPRAISALS_SUCCESS, GET_APPRAISALS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/homesaleAppraisals`,
      method: 'GET'
    }
  };
};

export const postAppraisal = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_APPRAISALS_REQUEST, POST_APPRAISALS_SUCCESS, POST_APPRAISALS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/homesaleAppraisals/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAppraisal = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_APPRAISALS_REQUEST, UPDATE_APPRAISALS_SUCCESS, UPDATE_APPRAISALS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/homesaleAppraisals/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

/* Homesale - Listings Requests */

export const getAllListings = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_LISTINGS_REQUEST, GET_LISTINGS_SUCCESS, GET_LISTINGS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/listings`,
      method: 'GET'
    }
  };
};

export const postListing = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_LISTINGS_REQUEST, POST_LISTINGS_SUCCESS, POST_LISTINGS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/listings/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateListing = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_LISTINGS_REQUEST, UPDATE_LISTINGS_SUCCESS, UPDATE_LISTINGS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/listings/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

/* Homesale - Equity Requests */

export const getEquity = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_EQUITY_REQUEST, GET_EQUITY_SUCCESS, GET_EQUITY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/equity`,
      method: 'GET'
    }
  };
};

export const postEquity = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_EQUITY_REQUEST, POST_EQUITY_SUCCESS, POST_EQUITY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/equity/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateEquity = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_EQUITY_REQUEST, UPDATE_EQUITY_SUCCESS, UPDATE_EQUITY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/equity/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteEquity = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_EQUITY_REQUEST, DELETE_EQUITY_SUCCESS, DELETE_EQUITY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/equity`,
      method: 'DELETE'
    }
  };
};

export const getTaxes = equityId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_TAX_REQUEST, GET_TAX_SUCCESS, GET_TAX_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${equityId}/tax`,
      method: 'GET'
    }
  };
};

export const postTax = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_TAX_REQUEST, POST_TAX_SUCCESS, POST_TAX_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/tax/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateTax = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_TAX_REQUEST, UPDATE_TAX_SUCCESS, UPDATE_TAX_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/tax/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteTax = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_TAX_REQUEST, DELETE_TAX_SUCCESS, DELETE_TAX_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/tax`,
      method: 'DELETE'
    }
  };
};

export const getCredits = equityId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CREDIT_REQUEST, GET_CREDIT_SUCCESS, GET_CREDIT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${equityId}/credit`,
      method: 'GET'
    }
  };
};

export const postCredit = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CREDIT_REQUEST, POST_CREDIT_SUCCESS, POST_CREDIT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/credit/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateCredit = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_CREDIT_REQUEST, UPDATE_CREDIT_SUCCESS, UPDATE_CREDIT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/credit/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteCredit = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_CREDIT_REQUEST, DELETE_CREDIT_SUCCESS, DELETE_CREDIT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/credit`,
      method: 'DELETE'
    }
  };
};

/* ^ End Homesale Equity */

export const getInspectors = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_INSPECTORS_REQUEST, GET_INSPECTORS_SUCCESS, GET_INSPECTORS_FAILURE],
      authenticated: true,
      endpoint: 'api/inspectors',
      method: 'GET'
    }
  };
};

export const postInspector = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_INSPECTORS_REQUEST, POST_INSPECTORS_SUCCESS, POST_INSPECTORS_FAILURE],
      authenticated: true,
      endpoint: 'api/inspectors',
      method: 'POST',
      payload: values
    }
  };
};

export const updateInspector = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_INSPECTORS_REQUEST, UPDATE_INSPECTIONS_SUCCESS, UPDATE_INSPECTORS_FAILURE],
      authenticated: true,
      endpoint: 'api/inspectors',
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteInspector = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_INSPECTORS_REQUEST, DELETE_INSPECTORS_SUCCESS, DELETE_INSPECTORS_FAILURE],
      authenticated: true,
      endpoint: `api/inspectors/${id}`,
      method: 'DELETE'
    }
  };
};

export const getInspections = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_INSPECTIONS_REQUEST, GET_INSPECTIONS_SUCCESS, GET_INSPECTIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/inspections`,
      method: 'GET'
    }
  };
};

export const postInspection = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_INSPECTIONS_REQUEST, POST_INSPECTIONS_SUCCESS, POST_INSPECTIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/inspections/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateInspection = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_INSPECTIONS_REQUEST, UPDATE_INSPECTIONS_SUCCESS, UPDATE_INSPECTIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/inspections/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteInspection = (authId, id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_INSPECTIONS_REQUEST, DELETE_INSPECTIONS_REQUEST, DELETE_INSPECTIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/inspections/${id}`,
      method: 'DELETE'
    }
  };
};

export const updateInspectionState = inspections => {
  return { type: UPDATE_INSPECTIONS_STATE, response: inspections };
};

export const getTitleReps = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_TITLE_REP_REQUEST, GET_TITLE_REP_SUCCESS, GET_TITLE_REP_FAILURE],
      authenticated: true,
      endpoint: 'api/titleRep'
    }
  };
};

export const getExpenseCodes = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_EXPENSE_CODES_REQUEST, GET_EXPENSE_CODES_SUCCESS, GET_EXPENSE_CODES_FAILURE],
      authenticated: true,
      endpoint: 'api/ExpenseCodes',
      method: 'GET'
    }
  };
};

export const postTitleRep = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_TITLE_REP_REQUEST, POST_TITLE_REP_SUCCESS, POST_TITLE_REP_FAILURE],
      authenticated: true,
      endpoint: 'api/titleRep',
      method: 'POST',
      payload: values
    }
  };
};

export const postExpenseCodes = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_EXPENSE_CODES_REQUEST, POST_EXPENSE_CODES_SUCCESS, POST_EXPENSE_CODES_FAILURE],
      authenticated: true,
      endpoint: 'api/ExpenseCodes',
      method: 'POST',
      payload: values
    }
  };
};

export const updateTitleRep = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_TITLE_REP_REQUEST, UPDATE_TITLE_REP_SUCCESS, UPDATE_TITLE_REP_FAILURE],
      authenticated: true,
      endpoint: 'api/titleRep',
      method: 'PUT',
      payload: values
    }
  };
};

export const updateExpenseCodes = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_EXPENSE_CODES_REQUEST, UPDATE_EXPENSE_CODES_SUCCESS, UPDATE_EXPENSE_CODES_FAILURE],
      authenticated: true,
      endpoint: 'api/ExpenseCodes',
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteTitleRep = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_TITLE_REP_REQUEST, DELETE_TITLE_REP_SUCCESS, DELETE_TITLE_REP_FAILURE],
      authenticated: true,
      endpoint: `api/titleRep/${id}`,
      method: 'DELETE'
    }
  };
};

export const deleteExpenseCode = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_EXPENSE_CODES_REQUEST, DELETE_EXPENSE_CODES_SUCCESS, DELETE_EXPENSE_CODES_FAILURE],
      authenticated: true,
      endpoint: `api/ExpenseCodes/${id}`,
      method: 'DELETE'
    }
  };
};

export const getHomesaleResaleOffers = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_HOMESALE_RESALE_OFFER_REQUEST, GET_ALL_HOMESALE_RESALE_OFFER_SUCCESS, GET_ALL_HOMESALE_RESALE_OFFER_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/homesaleResale/${id}`,
      method: 'GET'
    }
  };
};

export const getHomesaleResaleOffer = offerId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_HOMESALE_RESALE_OFFER_REQUEST, GET_HOMESALE_RESALE_OFFER_SUCCESS, GET_HOMESALE_RESALE_OFFER_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/homesaleResale/getById/${offerId}`,
      method: 'GET'
    }
  };
};

export const postHomesaleResaleOffer = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_HOMESALE_RESALE_OFFER_REQUEST, POST_HOMESALE_RESALE_OFFER_SUCCESS, POST_HOMESALE_RESALE_OFFER_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/homesaleResale',
      method: 'POST',
      payload: values
    }
  };
};

export const updateHomesaleResaleOffer = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_HOMESALE_RESALE_OFFER_REQUEST, UPDATE_HOMESALE_RESALE_OFFER_SUCCESS, UPDATE_HOMESALE_RESALE_OFFER_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/homesaleResale',
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteHomesaleResaleOffer = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_HOMESALE_RESALE_OFFER_REQUEST, DELETE_HOMESALE_RESALE_OFFER_SUCCESS, DELETE_HOMESALE_RESALE_OFFER_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/homesaleResale/${id}`,
      method: 'DELETE'
    }
  };
};

// Candidate Services

export const getCandidateServices = authorizationId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CANDIDATE_SERVICES_REQUEST, GET_CANDIDATE_SERVICES_SUCCESS, GET_CANDIDATE_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authorizationId}/candidateInternService/candidate`,
      method: 'GET'
    }
  };
};

export const postCandidateServices = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CANDIDATE_SERVICES_REQUEST, POST_CANDIDATE_SERVICES_SUCCESS, POST_CANDIDATE_SERVICES_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/candidateInternService/candidate',
      method: 'POST',
      payload: values
    }
  };
};

export const updateCandidateServices = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_CANDIDATE_SERVICES_REQUEST, UPDATE_CANDIDATE_SERVICES_SUCCESS, UPDATE_CANDIDATE_SERVICES_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/candidateInternService/candidate',
      method: 'PUT',
      payload: values
    }
  };
};

export const getInternServices = authorizationId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_INTERN_SERVICES_REQUEST, GET_INTERN_SERVICES_SUCCESS, GET_INTERN_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authorizationId}/candidateInternService/intern`,
      method: 'GET'
    }
  };
};

export const postInternServices = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_INTERN_SERVICES_REQUEST, POST_INTERN_SERVICES_SUCCESS, POST_INTERN_SERVICES_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/candidateInternService/intern',
      method: 'POST',
      payload: values
    }
  };
};

export const updateInternServices = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_INTERN_SERVICES_REQUEST, UPDATE_INTERN_SERVICES_SUCCESS, UPDATE_INTERN_SERVICES_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/candidateInternService/intern',
      method: 'PUT',
      payload: values
    }
  };
};

// Candidate Trips

export const getCandidateTrips = serviceId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_CANDIDATE_TRIPS_REQUEST, GET_ALL_CANDIDATE_TRIPS_SUCCESS, GET_ALL_CANDIDATE_TRIPS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/candidateInternService/candidateInternTrip/${serviceId}`,
      method: 'GET'
    }
  };
};

export const getCandidateTripById = tripId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CANDIDATE_TRIP_REQUEST, GET_CANDIDATE_TRIP_SUCCESS, GET_CANDIDATE_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/candidateInternService/candidateInternTrip/getById/${tripId}`,
      method: 'GET'
    }
  };
};

export const upsertCandidateTrip = (serviceId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPSERT_CANDIDATE_TRIP_REQUEST, UPSERT_CANDIDATE_TRIP_SUCCESS, UPSERT_CANDIDATE_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/candidateInternService/candidateInternTrip/${serviceId}`,
      method: 'POST',
      payload: values
    }
  };
};

export const deleteCandidateTrip = tripId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_CANDIDATE_TRIP_REQUEST, DELETE_CANDIDATE_TRIP_SUCCESS, DELETE_CANDIDATE_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/candidateInternService/candidateInternTrip/${tripId}`,
      method: 'DELETE'
    }
  };
};

// Destination trip endpoints

export const getDestinationBuyerTrips = serviceId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_BUYER_TRIPS_REQUEST, GET_ALL_BUYER_TRIPS_SUCCESS, GET_ALL_BUYER_TRIPS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/destinationService/buyerTrip/${serviceId}`,
      method: 'GET'
    }
  };
};

export const getBuyerTripById = tripId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_BUYER_TRIP_REQUEST, GET_BUYER_TRIP_SUCCESS, GET_BUYER_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/destinationService/buyerTrip/getById/${tripId}`,
      method: 'GET'
    }
  };
};

export const upsertBuyerTrip = (serviceId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPSERT_BUYER_TRIP_REQUEST, UPSERT_BUYER_TRIP_SUCCESS, UPSERT_BUYER_TRIP_FAILURE],
      authenticated: true,
      endpoint:`api/authorizations/destinationService/buyerTrip/${serviceId}`,
      method: 'POST',
      payload: values,
      context: serviceId
    }
  };
};

export const deleteBuyerTrip = tripId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_BUYER_TRIP_REQUEST, DELETE_BUYER_TRIP_SUCCESS, DELETE_BUYER_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/destinationService/buyerTrip/${tripId}`,
      method: 'DELETE'
    }
  };
};

export const getDestinationRenterTrips = serviceId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_RENTER_TRIPS_REQUEST, GET_ALL_RENTER_TRIPS_SUCCESS, GET_ALL_RENTER_TRIPS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/destinationService/renterTrip/${serviceId}`,
      method: 'GET'
    }
  };
};

export const getRenterTripById = tripId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_RENTER_TRIP_REQUEST, GET_RENTER_TRIP_SUCCESS, GET_RENTER_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/destinationService/renterTrip/getById/${tripId}`,
      method: 'GET'
    }
  };
};

export const upsertRenterTrip = (serviceId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPSERT_RENTER_TRIP_REQUEST, UPSERT_RENTER_TRIP_SUCCESS, UPSERT_RENTER_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/destinationService/renterTrip/${serviceId}`,
      method: 'POST',
      payload: values,
      context: serviceId
    }
  };
};

export const deleteRenterTrip = tripId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_RENTER_TRIP_REQUEST, DELETE_RENTER_TRIP_SUCCESS, DELETE_RENTER_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/destinationService/renterTrip/${tripId}`,
      method: 'DELETE'
    }
  };
};

// Temporary Living Assignment Trip endpoints

export const getTemporaryLivingAssignmentTrips = serviceId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_TEMP_LIVING_TRIPS_REQUEST, GET_ALL_TEMP_LIVING_TRIPS_SUCCESS, GET_ALL_TEMP_LIVING_TRIPS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/tempLiving/trips/getAll/${serviceId}`,
      method: 'GET'
    }
  };
};

export const getTemporaryLivingTripById = tripId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_TEMP_LIVING_TRIP_REQUEST, GET_TEMP_LIVING_TRIP_SUCCESS, GET_TEMP_LIVING_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/tempLiving/trips/getById/${tripId}`,
      method: 'GET'
    }
  };
};

export const upsertTemporaryLivingTrip = (serviceId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPSERT_TEMP_LIVING_TRIP_REQUEST, UPSERT_TEMP_LIVING_TRIP_SUCCESS, UPSERT_TEMP_LIVING_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/tempLiving/trips/${serviceId}`,
      method: 'POST',
      payload: values,
      context: serviceId
    }
  };
};

export const deleteTemporaryLivingTrip = tripId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_TEMP_LIVING_TRIP_REQUEST, DELETE_TEMP_LIVING_TRIP_SUCCESS, DELETE_TEMP_LIVING_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/tempLiving/trips/${tripId}`,
      method: 'DELETE'
    }
  };
};

export const getCostEstimates = authorizationId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_COST_ESTIMATES_REQUEST, GET_COST_ESTIMATES_SUCCESS, GET_COST_ESTIMATES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authorizationId}/costEstimates`,
      method: 'GET'
    }
  };
};

export const postCostEstimates = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_COST_ESTIMATES_REQUEST, POST_COST_ESTIMATES_SUCCESS, POST_COST_ESTIMATES_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/costEstimates',
      method: 'POST',
      payload: values
    }
  };
};

export const updateCostEstimates = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_COST_ESTIMATES_REQUEST, UPDATE_COST_ESTIMATES_SUCCESS, UPDATE_COST_ESTIMATES_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/costEstimates',
      method: 'PUT',
      payload: values
    }
  };
};
